function scrollElement(element) {
	var scrolled = window.pageYOffset || document.documentElement.scrollTop;
	var element = document.querySelector(element);
	element.style.transition = '0.3s transform linear';
	if(scrolled > element.parentNode.offsetHeight - element.offsetHeight) return;
	element.style.transform = `translateY(${scrolled}px)`;
}

module.exports = scrollElement;


// WEBPACK FOOTER //
// ./libs/scroll-element/scroll-element.js